/**
 * @generated SignedSource<<ebfd8958a9f620c0b5965b0317d16e8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion$data = {
  readonly id: string;
  readonly name: string;
  readonly project: {
    readonly key: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion">;
  readonly " $fragmentType": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion";
};
export type latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion$key = {
  readonly " $data"?: latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "key"
            },
            "action": "THROW",
            "path": "project.key"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    },
    {
      "kind": "FragmentSpread",
      "name": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "636e16e48d5710e3c9d238bef208f75d";

export default node;
